import * as React from "react";
import { Box, Typography } from "@mui/material";

export const getAnalysisContainerDetails = (container = {}) =>
  [container.type, container.size, container.sizeUnit ?? container.size_unit]
    .filter((value) => value !== null && value !== undefined && value !== "")
    .join(", ");

export const renderAnalysisContainerLabel = (container) => {
  if (!container) {
    return "";
  }

  const containerDetails = getAnalysisContainerDetails(container);

  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "baseline", minWidth: 0 }}>
      <Typography component="span" noWrap>
        {container.name}
      </Typography>
      {containerDetails && (
        <Typography
          component="span"
          noWrap
          sx={{ color: "text.secondary", fontStyle: "italic", ml: 0.75 }}>
          {`- ${containerDetails}`}
        </Typography>
      )}
    </Box>
  );
};
